import styled from "@emotion/styled";
import { TotalCountBadge } from "src/components/TotalCountBadge";
import { Agreement03 } from "src/assets/icons/agreement-03";
import { PrimaryButton } from "src/components/Buttons";
import { Skeleton } from "src/components/Skeleton";

export const MainPaneContainer = styled.div`
  flex-grow: 1;
  padding: 32px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 0px 24px;
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const HeaderTitle = styled.div<{ isDashboard: boolean }>`
  color: rgba(17, 24, 39, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 28px;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 1cap;
`;

export const HeaderSubTitle = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 14px
  font-weight: 400;
  line-height: 1cap;
`;

export const InviteButton = styled(PrimaryButton)`
  font-size: 14px;
  height: 38px;
`;

export default ({
  showHeading,
  page,
  headerTitleText,
  totalCount,
  headerSubTitleText,
  showNewApplication,
  onNewApplication,
  headerAction,
  children,
  isLoading = false,
}: {
  showHeading: boolean;
  page: string;
  headerTitleText: string;
  totalCount?: number;
  headerSubTitleText: string;
  showNewApplication: boolean;
  onNewApplication: () => void;
  headerAction?: React.ReactNode;
  children: React.ReactNode;
  isLoading?: boolean;
}) => {
  return (
    <MainPaneContainer>
      {showHeading && (
        <HeaderContainer>
          <HeaderTitleContainer>
            {isLoading ? (
              <>
                <Skeleton width="300px" height="32px" borderRadius="8px" />
                <Skeleton width="400px" height="14px" borderRadius="4px" />
              </>
            ) : (
              <>
                <HeaderTitle isDashboard={page === "dashboard"}>
                  {headerTitleText}
                  {totalCount ? (
                    <TotalCountBadge>{totalCount}</TotalCountBadge>
                  ) : null}
                </HeaderTitle>
                <HeaderSubTitle>{headerSubTitleText}</HeaderSubTitle>
              </>
            )}
          </HeaderTitleContainer>
          {showNewApplication && !isLoading && (
            <InviteButton onClick={onNewApplication}>
              New application <Agreement03 />
            </InviteButton>
          )}
          {headerAction && !isLoading && headerAction}
        </HeaderContainer>
      )}
      {children}
    </MainPaneContainer>
  );
};
